const Map = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 8.99953V14.9995C22 17.4995 21.5 19.2495 20.38 20.3795L14 13.9995L21.73 6.26953C21.91 7.05953 22 7.95953 22 8.99953Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 9C2 4 4 2 9 2H15C18.96 2 21.04 3.26 21.73 6.27L6.26999 21.73C3.25999 21.04 2 18.96 2 15V12.94"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.38 20.38C19.25 21.5 17.5 22 15 22H9.00003C7.96003 22 7.06002 21.91 6.27002 21.73L14 14L20.38 20.38Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.23977 7.9807C6.91977 5.0507 11.3198 5.0507 11.9998 7.9807C12.3898 9.7007 11.3098 11.1607 10.3598 12.0607C9.66977 12.7207 8.57979 12.7207 7.87979 12.0607C6.92979 11.1607 5.83977 9.7007 6.23977 7.9807Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M9.0946 8.69922H9.10359" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export default Map;
